import { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { isChannelsModuleVisibleInPermissionList } from "commons/constants/permissions";

export function useCanViewChannelsModule() {
  const permissionIds = useSelector((state) => state.userState?.permissions);
  return isChannelsModuleVisibleInPermissionList(permissionIds);
}

export function useChannelsAccess() {
  const history = useHistory();
  const canViewChannels = useCanViewChannelsModule();

  useEffect(() => {
    if (!canViewChannels) {
      history.replace("/home");
    }
  }, [canViewChannels, history]);

  return { canViewChannels };
}

export function useChannelsListData() {
  const { canViewChannels } = useChannelsAccess();
  const channelsFromRedux = useSelector(
    (state) => state.channelState?.channels
  );
  const listSyncLoading = useSelector(
    (state) => state.channelState?.isLoading ?? false
  );
  const channels = useMemo(
    () => channelsFromRedux || [],
    [channelsFromRedux]
  );
  const isListEmptyLoading = listSyncLoading && channels.length === 0;

  return {
    canViewChannels,
    channels,
    loading: listSyncLoading,
    isListEmptyLoading,
  };
}
